<template>
  <div class="block">
    <header></header>
    <div class="dataTable block">
      <div class="tableHead">
        <div class="tabHeadLeft">
          <h4>文章列表</h4>
        </div>
        <div class="tabHeadRight">
          <span class="labelName">状态筛选</span>
          <el-select v-model="state" @change="getList">
            <el-option
              v-for="item in StateOptions.slice(0, 6)"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <!-- <el-button class="btn-newArticle" type="primary" @click="newArticle">
            新建文章
          </el-button> -->
        </div>
      </div>
      <el-alert
        title="配置新活动请使用动态列表"
        type="warning"
        show-icon
        style="margin-bottom: 20px"
      >
        <template #title>
          <el-link type="primary" @click="goTrendList"
            >配置新活动请使用动态列表</el-link
          >
        </template>
      </el-alert>
      <el-table :data="list" border stripe>
        <el-table-column
          v-for="col in columns"
          :prop="col.id"
          :key="col.id"
          :label="col.label"
          :width="col.width ? col.width : 'auto'"
        >
          <template v-if="col.id === 'last_time'" #default="scope">
            {{ scope.row.last_time | formatDate }}
          </template>
          <template v-else-if="col.id === 'category'" #default="scope">
            {{ scope.row.category | getClassfy }}
          </template>
          <template v-else-if="col.id === 'option'" #default="scope">
            <el-link
              type="primary"
              @click="handleOpts(scope.row, 1)"
              :underline="false"
              >编辑</el-link
            >
            |
            <el-link
              v-if="scope.row.state == 0"
              type="primary"
              @click="handleOpts(scope.row, 2)"
              :underline="false"
              >下架</el-link
            >
            <el-link
              v-else
              type="primary"
              @click="handleOpts(scope.row, 3)"
              :underline="false"
              >上架</el-link
            >
            |
            <el-link
              type="primary"
              @click="handleOpts(scope.row, 4)"
              :underline="false"
              >复制链接</el-link
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="data-filter-page">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pagination.page_size"
          @size-change="allPageSizeChange"
          @current-change="allDataPageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { formatTime } from '../../../base/CONST';
import { actConfApi } from '../../../api/actConf';
import { CLASSFY } from './CONST';
import Clipboard from 'clipboard';
const { getArticleByUin, updateArticleState } = actConfApi;
let copyIng = false;
const clipboardDestroy = (clipboard, e) => {
  e.clearSelection();
  clipboard.destroy();
  clipboard = null;
  setTimeout(() => {
    copyIng = false;
  }, 250);
};
export default {
  data() {
    return {
      state: 0,
      StateOptions: [
        { text: '上架', value: 0 },
        { text: '下架', value: 1 },
      ],
      pagination: {
        total: 0,
        page_size: 10,
        page: 1,
      },
      list: [],
      columns: [
        { label: 'ID', id: 'id' },
        { label: '标题', id: 'title' },
        { label: '分类', id: 'category' },
        { label: '所属地图', id: 'map_id' },
        { label: '最后编辑时间', id: 'last_time' },
        { label: '操作', id: 'option' },
      ],
      isProd: ~location.href.indexOf('kfz.mini1.cn'),
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goTrendList() {
      this.$router.push({ name: 'actTrendConfList' });
    },
    copyArticleLink(id) {
      if (copyIng) return;
      copyIng = true;
      console.log('复制文章链接', id);
      const currActiveElement = document.activeElement;
      try {
        // eslint-disable-next-line prefer-const
        let clipboard = new Clipboard(currActiveElement, {
          text: () => {
            const path = '.mini1.cn/activity/activity-article/#/article/';
            return `s4_https://kfz${
              this.isProd ? '' : '-test'
            }${path}${id}?openBrowser=3&portrait=2`;
          },
          target: trigger => {
            return trigger;
          },
          container: currActiveElement,
        });
        clipboard.on('success', e => {
          this.successTips('已复制');
          clipboardDestroy(clipboard, e);
        });
        clipboard.on('error', e => {
          this.errorTips(JSON.stringify(e));
          clipboardDestroy(clipboard, e);
        });
      } catch (err) {
        console.log(err);
      }
    },
    getList() {
      getArticleByUin({
        json: 1,
        page: this.pagination.page,
        page_size: this.pagination.page_size,
        state: this.state,
      }).then(res => {
        console.log('getArticleByUin----', res);
        const { code, data } = res;
        if (code === 0) {
          this.list = data.list.length ? data.list : [];
          this.pagination.total = parseInt(data.total, 10);
        }
      });
    },
    newArticle() {
      this.$router.push({ name: 'actArticleConf', params: { id: 0 } });
    },
    editArticle(id) {
      this.$router.push({ name: 'actArticleConf', params: { id } });
    },
    allDataPageChange(page) {
      this.pagination.page = page;
      this.getList();
    },
    allPageSizeChange(pageSize) {
      this.pagination.page_size = pageSize;
      this.pagination.page = 1;
      this.getList();
      // this.getAllList(this.pagination);
    },
    handleOpts(rowInfo, type) {
      switch (type) {
        case 1: // 编辑文章
          this.editArticle(rowInfo.id);
          break;
        case 2: // 下架文章
        case 3: // 上架文章
          updateArticleState({ id: rowInfo.id, state: 3 - type, json: 1 }).then(
            res => {
              console.log('上下架操作', res);
              if (res.code == 0) {
                this.$message
                  ? this.$message.success('操作成功')
                  : this.$toast('操作成功');
                this.getList();
              }
            },
          );
          break;
        case 4: // 复制文章链接
          this.copyArticleLink(rowInfo.id);
          break;
      }
    },
    errorTips(msg) {
      return this.$message ? this.$message.error(msg) : this.$toast.fail(msg);
    },
    successTips(msg) {
      return this.$message ? this.$message.success(msg) : this.$toast(msg);
    },
  },
  filters: {
    formatDate(time) {
      return formatTime(time, true);
    },
    getClassfy(val) {
      return CLASSFY[val].label;
    },
  },
};
</script>
<style src="../../../style/common-pc.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.dataTable {
  // border-top: 1px solid #d9d9d9;
  margin: 0 auto 0;
  // padding-top: 32px;
}
.tableHead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 27px;
  .tabHeadLeft {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    flex: 1 0 auto;
    h4 {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #262626;
      line-height: 33px;
      margin-right: 20px;
    }
    span {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
    }
  }
  .tabHeadRight {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .labelName {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
      margin-right: 14px;
    }
    .btn-newArticle {
      margin-left: 24px;
    }
  }
}
.data-filter-page {
  margin-top: 24px;
}
</style>
